<div [class]="wrapperClass()">
  <textarea
    #field
    class="bz-textarea__field"
    [value]="value()"
    [rows]="rows()"
    [style.--bz-textarea-rows]="rows()"
    [placeholder]="placeholder()"
    [disabled]="disabled()"
    [readOnly]="readonly()"
    [attr.maxlength]="maxLength()"
    [attr.aria-invalid]="invalid() ? 'true' : null"
    [attr.aria-label]="ariaLabel() || null"
    [attr.aria-describedby]="counter() ? counterId : null"
    (input)="onInput($event)"
    (blur)="markTouched()"
  ></textarea>
</div>

@if (counter(); as counter) {
  <!--
    Described rather than live: `aria-describedby` reads the count when the
    field takes focus, which is when it is useful. An aria-live region would
    announce a new number on every keystroke.
  -->
  <p class="bz-textarea__counter" [id]="counterId">{{ counter }}</p>
}
